module.exports = __webpack_public_path__ + "static/img/my-login.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/my-login.png
// module id = 575
// module chunks = 0